import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {
  amber,
  blue,
  gray,
  green,
  red,
  transparent,
  white,
  yellow,
} from 'tailwindcss/colors';

export const ZoneTheme = definePreset(Aura, {
  primitive: {
    green,
    red,
    blue,
    gray,
    yellow,
    orange: {
      50: '#fff5ec',
      100: '#ffe3c7',
      200: '#ffc999',
      300: '#ff9d5c',
      400: '#fa7a1a',
      500: '#e8410a',
      600: '#c92f08',
      700: '#a3240a',
      800: '#7c1a0a',
      900: '#5a1307',
      950: '#2e0702',
    },
    amber,
    white,
    transparent,
    surface: '#eff3f8',
    black: '#011457',
  },
  semantic: {
    primary: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#3b82f6',
      600: '#2563eb',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#153b7a',
      950: '#172554',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#153b7a',
          inverseColor: '#ffffff',
          hoverColor: '#172554',
          activeColor: '#172554',
        },
      },
    },
  },
  components: {
    progressbar: {
      root: {
        height: '4px',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
html {
  font-size: 0.875rem;

  textarea {
    border: 1px solid ${dt('gray.300')};
    border-radius: 6px;
    width: 100%;
  }

  .p-inputtext,
  .p-dropdown,
  .p-datepicker {
    width: 100%;
  }

  .p-breadcrumb-item-link {
    color: ${dt('gray.700')};
  }

  .p-menu {
    a.p-menu-item-link-active {
      background-color: ${dt('gray.100')};
    }

    a.p-menu-item-link {
      color: ${dt('gray.700')};
      padding: 10.5px 14px;
    }

    .p-menu-item-icon {
      color: ${dt('gray.700')};
    }
  }

  .p-panelmenu {
    a.p-panelmenu-header-link {
      color: ${dt('gray.700')} !important;
      
      .p-panelmenu-submenu-icon {
        color: ${dt('gray.700')};
      }
    }
  }

  .p-button {
    border-radius: 2rem;
    transition: background-color 0.3s;
    text-transform: uppercase;
    font-weight: 700;
    justify-content: center;

    &:not(.p-button-icon-only) {
      padding: 0.75rem 1rem;
    }
  }

  p-buttongroup {
      .p-button-warn {
        border: 2px solid ${dt('orange.500')};
      }

      .p-button-text {
        border: 2px solid;
      }
  }

  .p-button-label {
    text-transform: uppercase;
    font-weight: 700;
    flex: 0 1 auto;
    width: max-content;
  }

  .pi {
    font-weight: inherit !important;
  }

  .p-dialog-content,
  .p-dialog-header,
  .p-dialog-footer {
    text-align: center;
    background-color: ${dt('surface')} !important;
    color: ${dt('primary.950')} !important;

  }

  .p-dialog-footer {
    display: flex;
    place-content: center;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
  }

  p-dialog .p-dialog-content {
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
  }

  .p-dialog-header {
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    color: ${dt('primary.700')};
  }

  .p-dialog-header-icons {
    align-self: baseline;
  }

  .p-dialog-title {
    flex: 1;
    font-weight: 600;
    font-size: 1.5rem;
  }

  .p-radiobutton.p-radiobutton-warn.p-radiobutton-checked {
    .p-radiobutton-box {
      background-color: ${dt('orange.500')};
      border: 2px solid ${dt('gray.400')};

      .p-radiobutton-icon {
        display: none;
      }
    }

    &:not(.p-disabled):has(.p-radiobutton-input:hover) {
      .p-radiobutton-box {
        background-color: ${dt('orange.500')};
        border: 2px solid ${dt('gray.400')};
      }
    }
  }

  .rounded-checkbox {
    .p-checkbox-box {
      border-radius: 1rem !important;
      min-width: 1.4rem !important;
      min-height: 1.4rem !important;
      align-self: center;
    }

    .p-highlight .p-checkbox-box{
        background-color: ${dt('orange.500')};
        border-color: ${dt('gray.400')};
    }

    .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
        background-color: ${dt('orange.500')};
        border-color: ${dt('gray.400')};
    }
  }

  .p-breadcrumb {
    border: none;
    background-color: transparent;

    .p-breadcrumb-list {
      li:last-child .p-breadcrumb-item-label {
        color: ${dt('orange.500')};
        text-decoration: underline;
      }
      .p-breadcrumb-item-link {
        cursor: pointer;
      }
    }
  }
}
  `,
});
